import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.addEventListener('error', (e) => {
  if (e.target.tagName === 'IMG') {
    e.target.style.visibility = 'hidden';
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals();